import store from '@/store/store'

class BusyButtonsModule {

  setButtonBusy(id, isLoading) {
    store.commit('BUSY_BUTTON_SET', { id, isLoading })
  }

  isButtonBusy(id) {
    return store.state.busyButtons[id]
  }
}

export default new BusyButtonsModule()
